export const campaignIds = {
  "christmas-urgency-messaging-banner": "christmas-urgency-messaging-banner"
}
